import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '时尚穿搭', path: '/category/shishang-chuanda' },
    { label: '护肤保养', path: '/category/hufu-baoyang' },
    { label: '生活美学', path: '/category/shenghuo-meixue' },
    { label: '自我成长', path: '/category/ziwo-chengzhang' },
    { label: '关于我们', path: '/about' },
  ],
  articles: [
    { label: '30岁女性春秋职场穿搭指南', path: '/article/30sui-nvxing-chunqiu-zhibo-dapei' },
    { label: '35岁后抗衰老护肤方案', path: '/article/35sui-hou-kangshuailao-hufu-fangan' },
    { label: '熟女的居家美学', path: '/article/shunv-jiaju-buzhi-meixue' },
    { label: '40岁女性自我提升之路', path: '/article/40sui-nvxing-ziwo-tisheng-zhilu' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <h3 className="font-heading text-xl font-semibold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                熟女魅力
              </h3>
              <p className="text-sm text-background-300 leading-relaxed font-label">
                探索成熟女性的独特魅力，从时尚穿搭、护肤保养到生活美学与自我成长，
                为30岁以上女性提供实用的风格指南与生活建议。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="https://weibo.com" target="_blank" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="https://xiaohongshu.com" target="_blank" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-red-packet-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-label font-medium text-background-50 mb-4 text-sm">快速导航</h4>
              <ul className="space-y-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-sm text-background-300 hover:text-primary-400 transition-colors font-label cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-label font-medium text-background-50 mb-4 text-sm">热门文章</h4>
              <ul className="space-y-2.5">
                {footerLinks.articles.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-sm text-background-300 hover:text-primary-400 transition-colors font-label cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400 font-label">
              &copy; {new Date().getFullYear()} 熟女魅力. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors font-label">隐私政策</a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors font-label">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}